module.exports = __webpack_public_path__ + "static/body_9-93693d7e66823971f7e500253cb92ffd.png";